export const UILAB_NG_MAT_COMPONENTS_PACKAGE = '@uilab/ng-mat-components';
export const UILAB_BASE_COMPONENT_PACKAGE = '@uilab/base-components-angular';
